import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../../../../environments/appconfig';
import { Injectable } from '@angular/core';
import { MaFormadepago } from '../dominio/maformadepago';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';

@Injectable()
export class MaFormadePagoService {
    private url = `${this.config.getEnv('proxy')}spring/core/maformadepago/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarActivos(): Promise<MaFormadepago[]> {
        return this.http.get(`${this.url}listarActivos`,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as MaFormadepago[];
            })
            .catch(error => []);
    }

}
